import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=cbf7ae30"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbf7ae30')) {
      api.createRecord('cbf7ae30', component.options)
    } else {
      api.reload('cbf7ae30', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=cbf7ae30", function () {
      api.rerender('cbf7ae30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/profile/ResetPassword.vue"
export default component.exports